/**
 * 路由 path → hub 配置键（与 router meta.hubKey 一致，供 meta 未合并时兜底）
 */
export const CARE_PLAN_HUB_PATH_TO_KEY = {
  "/NursingGroupManage": "NursingGroupManage",
  "/NursingTaskManage": "NursingTaskManage",
  "/NursingRecordPrdManage": "NursingRecordPrdManage",
  "/NursingIntegrateView": "NursingIntegrateView",
  "/NursingStatsDashboard": "NursingStatsDashboard"
};

/**
 * 护理计划模块 - 五大功能域子菜单（与 menuUtil / PRD 5.1 一致）
 */
export const CARE_PLAN_HUBS = {
  NursingGroupManage: {
    title: "护理组管理",
    description: "护理团队、组长、负责区域与排班配置（PRD 6.3）",
    children: [
      { title: "护理组增加", path: "/CareNursingGroupAdd", icon: "el-icon-plus", desc: "新建护理组并指定组长、区域" },
      { title: "护理组变更", path: "/CareNursingGroupChange", icon: "el-icon-edit", desc: "修改组名、组长、组员与负责区域" },
      { title: "护理组查询", path: "/CareNursingGroupQuery", icon: "el-icon-search", desc: "按名称、状态、组长查询" },
      { title: "班次设置", path: "/RoomShiftSetting", icon: "el-icon-time", desc: "白班/夜班等班次时间" },
      { title: "排班管理", path: "/RoomScheduleIndex", icon: "el-icon-date", desc: "护理人员排班计划" }
    ]
  },
  NursingTaskManage: {
    title: "护理任务管理",
    description: "计划生成任务、监控执行、打卡与异常（PRD 6.1、6.6.3）",
    children: [
      { title: "任务自动生成", path: "/CareNursingTaskGenerate", icon: "el-icon-refresh", desc: "按生效计划生成未来任务" },
      { title: "任务监控", path: "/CareNursingTaskMonitor", icon: "el-icon-view", desc: "时间轴与状态统计" },
      { title: "任务执行打卡", path: "/CareNursingTaskPunch", icon: "el-icon-check", desc: "开始/完成打卡" },
      { title: "超时预警", path: "/CareNursingTaskTimeout", icon: "el-icon-warning", desc: "超时任务处理" },
      { title: "异常上报", path: "/CareNursingTaskException", icon: "el-icon-warning-outline", desc: "执行中异常登记" }
    ]
  },
  NursingRecordPrdManage: {
    title: "护理记录管理",
    description: "计划模块内护理执行记录（PRD 6.4，与日常护理记录表区分）",
    children: [
      { title: "记录查看", path: "/CareNursingRecordView", icon: "el-icon-document", desc: "分页查询与筛选" },
      { title: "记录新增", path: "/CareNursingRecordAdd", icon: "el-icon-plus", desc: "手动补录" },
      { title: "记录修改", path: "/CareNursingRecordEdit", icon: "el-icon-edit", desc: "备注、结束时间" },
      { title: "记录删除", path: "/CareNursingRecordDelete", icon: "el-icon-delete", desc: "软删除与原因" },
      { title: "记录导出", path: "/CareNursingRecordExport", icon: "el-icon-download", desc: "导出 Excel" }
    ]
  },
  NursingIntegrateView: {
    title: "整合查看",
    description: "护理计划、护理记录、生活记录整合为 Markdown 报告（PRD 6.5）",
    children: [
      { title: "护理计划查看", path: "/CareIntegratePlanView", icon: "el-icon-notebook-2", desc: "整合报告含计划概览", integrateType: 1 },
      { title: "护理记录查看", path: "/CareIntegrateNursingRecordView", icon: "el-icon-document", desc: "计划模块护理记录", integrateType: 2 },
      { title: "生活记录查看", path: "/CareIntegrateLifeView", icon: "el-icon-coffee-cup", desc: "日常护理记录表", integrateType: 3 },
      { title: "定制护理记录查看", path: "/CareIntegrateCustomView", icon: "el-icon-tickets", desc: "定制类型（待扩展）", integrateType: 1 },
      { title: "整合报告导出（MD）", path: "/CareIntegrateMdExport", icon: "el-icon-download", desc: "预览并导出 .md", integrateType: 1 }
    ]
  },
  NursingStatsDashboard: {
    title: "数据统计",
    description: "执行率、工作量、超时率（PRD 6.6.4）",
    children: [
      { title: "执行率统计", path: "/CareStatsExecution", icon: "el-icon-data-line", desc: "任务完成率趋势", statsTab: "execution" },
      { title: "工作量统计", path: "/CareStatsWorkload", icon: "el-icon-user", desc: "护工任务量", statsTab: "workload" },
      { title: "超时率统计", path: "/CareStatsTimeout", icon: "el-icon-warning", desc: "超时分布", statsTab: "timeout" }
    ]
  }
};
